<p-toast position="top-right"></p-toast>
<div class="p-g">
    <div class="p-g-12">
        <div class="card card-w-title">
            <h1>{{setLabel("notificationsManagementLabel")}}</h1>
            <p-table #dt [value]="Notifications" dataKey="id" class="p-table-tecfolk-fix" styleClass="p-table-customers"
                [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
                currentPageReportTemplate="There are {{
                    Notifications?.length
                }} records" [filterDelay]="0" [globalFilterFields]="[
                    'name',
                    'country.name',
                    'representative.name',
                    'status'
                ]">
                <ng-template pTemplate="caption">
                    <div class="p-table-globalfilter-container">
                        <input pinputtext="" [(ngModel)]="Notification.title" autocomplete="off" [placeholder]='setLabel("searchPlaceholderLabel")'
                            type="text" name="searchValue" (keyup)="searchLocal(Notification.title, 'title')"
                            class="p-inputtext p-corner-all p-state-default p-widget" />
                        <button style="
                                background: #ffffff;
                                color: #0e2031;
                                margin-top: 10px;" (click)="resetFilter()"
                            class="p-button p-widget p-state-default p-corner-all p-button-text-only">{{setLabel("clearBtnLabel")}}</button>&nbsp;
                        <button style="
                                background: #ffffff;
                                color: #0e2031;
                                margin-top: 10px;
                            " routerLink="notification"
                            class="p-button p-widget p-state-default p-corner-all p-button-text-only">{{setLabel("addNewBtnLabel")}}</button>&nbsp;
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{setLabel("titleLabel")}}</th>
                        <!-- <th>Message Body</th> -->
                        <th>{{setLabel("sendingToLabel")}}</th>
                        <th>{{setLabel("statusLabel")}}</th>
                        <th>{{setLabel("date&TimeLabel")}}</th>
                        <th style="text-align: center;">{{setLabel("actionLabel")}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-notification>
                    <tr class="p-selectable-row">
                        <td>
                            <span class="p-column-title">{{
                                notification.title
                                }}</span>
                        </td>
                        <!-- <td>
                            <span class="p-column-title ">{{
                              notification.body
                                }}</span>
                        </td> -->
                        <td>
                            <span *ngFor="let item of notification.sendingTo" class="p-column-title">{{
                                item.memberType
                                }} <br></span>
                        </td>
                        <td>
                            <span class="p-column-title">{{
                                notification.status
                                }}</span>
                        </td>
                        <td>
                            <span style="vertical-align: middle; margin-left: 0.5em;
                                ">{{ notification.scheduleDate | date: 'short' }}</span>
                        </td>
                        <td style="text-align: center;">
                            <button pButton type="button" [pTooltip]='setLabel("deleteNotificationTooltipLabel")'
                                class="p-button-danger p-button" icon="fa fa-times"
                                (click)="deleteNotificationById(notification)"></button>
                            &nbsp;
                            <button pButton type="button" [pTooltip]='setLabel("detailsTooltipLabel")' icon="fa fa-pencil-square-o"
                                routerLink="notification/{{ notification._id }}"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6" style="text-align: left;">
                            {{setLabel("noNotificationsFoundLabel")}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>